import React from 'react'
import './FormSuccessBox.scss'
import {AnimatePresence, motion} from 'framer-motion'

export default function FormSuccessBox({text, close, visible}) {
	return(
		<AnimatePresence>
			{
				visible &&
				<div className="FormSuccessBox">
					<motion.div
						className="box"
						initial={{opacity: 0, y: -200}}
						animate={{opacity: 1, y: 0, transition: {delay: .2}}}
						exit={{opacity: 0}}
					>
						<button className="close-button" onClick={close}>
							Lukk
						</button>
						<div className="content">
							<div className="text" dangerouslySetInnerHTML={{__html: text}} />
							<button onClick={close} className="Button primary">
								<span>Lukk</span>
							</button>
						</div>
					</motion.div>
					<motion.div
						className="bg"
						transition={{type: 'tween', duration: .3}}
						initial={{opacity: 0}}
						animate={{opacity: .96}}
						exit={{opacity: 0, transition: {delay: .2, type: 'tween', duration: .3}}}
						onClick={close}
						role="button"
					/>
				</div>
			}
		</AnimatePresence>
	)
}